/**
 * Quarterly Projects Page
 * Manage all quarterly operational expense projects
 */

import { useNavigate } from 'react-router';
import { addProject } from '../store';
import { Project, Task } from '../types';
import { useApp } from '../providers/AppProvider';
import QuarterlyProjectsView from '../components/QuarterlyProjectsView';
import { useOrganizationData } from '../hooks/useOrganizationData';
import { canViewProjectFinance } from '../utils/projectAccess';
import { WIDGET_MUTED_TEXT_CLASS, WIDGET_PANEL_CLASS } from '../constants/widgetTheme';


export default function QuarterlyProjects() {
  const { state } = useApp();
  const navigate = useNavigate();
  const { projects, tasks } = useOrganizationData(state) as {
    projects: Project[];
    tasks: Task[];
  };

  const financeProjects = projects.filter((project) =>
    canViewProjectFinance(state?.currentUser, project)
  );

  const handleCreateProject = (project: Project) => {
    addProject(project);
  };

  if (!state || !state.currentOrganization) {
    return (
      <div className="p-6 lg:p-8 max-w-7xl mx-auto">
        <div className="text-center py-12">
          <p className={WIDGET_MUTED_TEXT_CLASS}>Please select an organization</p>
        </div>
      </div>
    );
  }

  const { currentOrganization } = state;

  if (financeProjects.length === 0) {
    return (
      <div className="p-6 lg:p-8 max-w-7xl mx-auto">
        <div className={`${WIDGET_PANEL_CLASS} rounded-lg py-12 text-center`}>
          <p className={WIDGET_MUTED_TEXT_CLASS}>
            Financial data is restricted to project admins or owners.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 lg:p-8 max-w-7xl mx-auto">
      <QuarterlyProjectsView
        projects={financeProjects}
        tasks={tasks}
        organizationId={currentOrganization.id}
        organizationName={currentOrganization.name}
        onCreateProject={handleCreateProject}
      />
    </div>
  );
}
